import React, { useEffect } from "react";
import { PRODUCT } from "../Utils/variables";

//STEP 1:
//create components using React.lazy
const AnacityTheme = React.lazy(() => import("./AnacityTheme"));
const StratumTheme = React.lazy(() => import("./StratumTheme"));

//STEP 2:
//create a parent component that will load the components conditionally using React.Suspense
const ThemeSelector = ({ children }) => {
  const CHOSEN_THEME = PRODUCT;
  return (
    <>
      <React.Suspense fallback={<></>}>
        {CHOSEN_THEME === "ANACITY" && <AnacityTheme />}
        {(CHOSEN_THEME === "STRATUM" || CHOSEN_THEME === "DANUBE") && (
          <StratumTheme />
        )}
      </React.Suspense>
      {children}
    </>
  );
};
export default ThemeSelector;
